module.exports = __webpack_public_path__ + "static/media/cilantro.dd110285.jpg";